var React = require('react');

function IconPause (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"}));
}

IconPause.defaultProps = {"fill":"currentColor","viewBox":"0 0 16 16"};

module.exports = IconPause;

IconPause.default = IconPause;
